import { render, staticRenderFns } from "./DnbInformation.vue?vue&type=template&id=30164538&scoped=true"
import script from "./DnbInformation.vue?vue&type=script&lang=js"
export * from "./DnbInformation.vue?vue&type=script&lang=js"
import style0 from "./DnbInformation.vue?vue&type=style&index=0&id=30164538&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30164538",
  null
  
)

export default component.exports